export default __webpack_public_path__ + "static/media/download.dee75946.svg";